// extracted by mini-css-extract-plugin
export var countdownTimer = "countdown-timer-module--countdownTimer--b054b";
export var dark = "countdown-timer-module--dark--960e2";
export var light = "countdown-timer-module--light--ec089";
export var number = "countdown-timer-module--number--27e74";
export var numberContainer = "countdown-timer-module--numberContainer--03207";
export var numberSlash = "countdown-timer-module--numberSlash--f0b1a";